export default __webpack_public_path__ + "static/media/gray_close.d8dcdce1.svg";